import { createStore, compose, applyMiddleware } from "redux";
import rootReducer from "../reducers/root";
import { middleware as reduxPackMiddleware } from "redux-pack";
import actionToUrlQuery from "../middleware/actionToUrlQuery";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const composeEnhancers = compose;

const configureStore = (storeId, history) => {
  let middlewares = [reduxPackMiddleware];
  if (history) middlewares.push(actionToUrlQuery(history));
  if (process.env.NODE_ENV === "development") {
    const freeze = require("redux-freeze");
    middlewares.push(freeze);
  }

  const middleware = applyMiddleware(...middlewares);

  return createStore(rootReducer, undefined, composeEnhancers(middleware));
};

export default configureStore;
